// extracted by mini-css-extract-plugin
export default {"container":"SistemaDeIntervencionYControl_container__5Dn8i"};